import React, { Component } from "react";
import DefaultMenu from "./DefaultMenu";
import ClassicMenu from "./ClassicMenu";

class AppMenu extends Component {
  componentDidMount = () => {};

  render() {
    const { userAccount } = this.props;
    if (userAccount.acctTheme === 0) return <ClassicMenu {...this.props} />;
    return <DefaultMenu {...this.props} />;
  }
}

export default AppMenu;



// WEBPACK FOOTER //
// ./src/components/pages/AppMenu.js